// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I_XL","comment":"styles_comment__2BtiN"};